import { BaseRecord } from "./BaseRecord";
import { Country } from "./Country";

export class State extends BaseRecord<number> {
    public name: string;
    public code!:string;
    public countryId!: number;
    public country: Country | null;

    constructor() {
        super();
        this.id = 0;
        this.name = "";
        this.countryId = 0;
        this.country = new Country();
        this.code="";
    }
}
